export default {
    list: (state) => {
        return state.list
    },
    current_lead: (state) => {
        return state.current_lead
    }
}